import { createSlice } from '@reduxjs/toolkit';
import { getConfigsFeaturesLocation } from './actions';

const initialState = {
  data: [],
  isLoading: false,
  isError: false,
  errorMessage: '',
};

export const configs = createSlice({
  name: 'configs',
  initialState,
  reducers: {
    // reducers goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getConfigsFeaturesLocation.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = '';
      })
      .addCase(getConfigsFeaturesLocation.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getConfigsFeaturesLocation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      });
  },
});

export default configs.reducer;
